/**
 * Environment Configuration
 * Centralized access to environment variables with type safety.
 */

import { getApiBaseUrl, getAppBaseUrl, getFrontendUrl } from './baseUrl';

interface EnvConfig {
  /** Application environment mode */
  MODE: string;
  /** Base URL for API requests */
  API_BASE_URL: string;
  /** Application base URL */
  APP_URL: string;
  /** Frontend URL (for redirects, links, etc.) */
  FRONTEND_URL: string;
  /** Enable debug mode */
  DEBUG: boolean;
}

/**
 * Validates and retrieves environment configuration.
 * All environment variables should be prefixed with VITE_ in .env files.
 * Base URLs are managed centrally in baseUrl.ts
 */
export const env: EnvConfig = {
  MODE: import.meta.env.MODE || 'development',
  // Get base URLs from centralized configuration
  API_BASE_URL: getApiBaseUrl(),
  APP_URL: getAppBaseUrl(),
  FRONTEND_URL: getFrontendUrl(),
  DEBUG: import.meta.env.VITE_DEBUG === 'true',
};

/**
 * Check if the application is running in development mode.
 */
export const isDevelopment = (): boolean => env.MODE === 'development';

/**
 * Check if the application is running in production mode.
 */
export const isProduction = (): boolean => env.MODE === 'production';

/**
 * Check if debug mode is enabled.
 */
export const isDebug = (): boolean => env.DEBUG || isDevelopment();

